<template>
	<v-container fill-height>
		<v-row align="center">
			<v-row align="center" justify="center">
				<!-- PRIMAR Logo -->
				<LogoAnimation />

				<!-- ENC Coverage -->
				<CesiumCoverage />
			</v-row>

			<v-row class="mt-4" justify="center">
				<!-- Nav links -->
				<v-col xs="12" md="6">
					<v-row>
						<v-col
							:key="item.title"
							cols="12"
							sm='12'
							md='12'
							lg="6"
							v-for="item in $options.navLinks"
						>
							<NavCard v-bind="item" />
						</v-col>
					</v-row>
				</v-col>

				<!-- Download ENC -->
				<v-col cols="12" md="6">
					<v-row>
						<v-col xs="12" md="10" lg="8" offset="0" offset-md="1" offset-lg="2">
							<NavCard
								_blank
								linkTo="https://primar.ecc.no/primar/portal/public/enc/downloadEnc.jsf"
								subTitle="Download the weekly PRIMAR CD content"
								title="PRIMAR CD Service"
								icon="mdi-download"
							/>
						</v-col>

						<v-col xs="12" md="10" lg="8" offset="0" offset-md="1" offset-lg="2">
							<NavCard
								_blank
								linkTo="https://primar.ecc.no/primar/"
								outlined
								subTitle="Go to the ENC distribution centre"
								title="PRIMAR Portal"
								icon="mdi-earth"
							/>
						</v-col>

						<v-col xs="12" md="10" lg="8" offset="0" offset-md="1" offset-lg="2">
							<NavCard
								_blank
								linkTo="https://primar.ecc.no/primar/portal/cc/mapClient.jsf"
								outlined
								subTitle=""
								title="PRIMAR Product Catalogue"
								icon="mdi-map-legend"
							/>
						</v-col>
						<v-col xs="12" md="10" lg="8" offset="0" offset-md="1" offset-lg="2">
							<NavCard
								_blank
								linkTo="https://primar.learnworlds.com/profile"
								outlined
								subTitle=""
								title="PRIMAR Training Portal"
								icon="mdi-school"
							/>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-row>
	</v-container>
</template>

<script>
import NavCard from '@/components/home/NavCard'
import CesiumCoverage from '@/components/home/CesiumCoverage'

import LogoAnimation from '@/components/home/LogoAnimation'

import NewsList from '@/components/n-collections/NewsList'

export default {
	name: 'Home',

	metaInfo: {
    title: 'Home'
  },

	components: {
		NavCard,
		CesiumCoverage,
		NewsList,
		LogoAnimation,
	},

	// Front page navigation cards
	navLinks: [
		{
			title: 'About',
			subTitle: 'Learn more about PRIMAR',
			linkTo: 'about',
			icon: 'mdi-information',
		},
		{
			title: 'Contact',
			subTitle: 'Get in touch with us',
			linkTo: 'contact',
			icon: 'mdi-email',
		},
		{
			title: 'Hydrographic Offices',
			subTitle: 'ENC Providers',
			linkTo: 'providers',
			icon: 'mdi-import',
		},
		{
			title: 'Distributors',
			subTitle: 'Providing ENC to end users',
			linkTo: 'distributors',
			icon: 'mdi-export',
		},
	],
}
</script>

<style lang="stylus">
.viewer
	height 100%
</style>
